<template>
	<v-dialog v-model="dialog" max-width="700px">
		<template v-slot:activator="{ on, attrs }">
			<v-btn :text="text" :color="text ? 'white' : 'secondary'" :class="text ? 'ml-2' : 'mb-2'" @click.stop="dialog = true" v-bind="attrs" v-on="on">
				<v-icon class="mr-2">mdi-magnify</v-icon>
				検索
			</v-btn>
		</template>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">日報検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form">
					<v-text-field v-model="q.name_cont" class="mt-4" label="顧客企業名" outlined dense />
					<v-text-field v-model="q.customer_code_eq" class="mt-4" label="得意先コード" outlined dense />
					<v-select
						:items="industries"
						item-text="name"
						item-value="id"
						v-model="q.industry_id_eq"
						class="mt-4"
						label="業種"
						clearable
						outlined
						dense
					/>
					<v-text-field v-model="q.company_tags_name_in" class="mt-4" label="タグ名" outlined dense />
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="0" sm="2"></v-col>
					<v-col cols="12" sm="8">
						<v-row class="ma-0 pa-0" justify="center">
							<v-btn class="ma-1" @click="searchCustomerCompanies" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
							<v-btn class="ma-1" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-row>
					</v-col>
					<v-col cols="0" sm="2">
						<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
		query: { type: Object, required: true, default: () => {} },
		industries: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			dialog: false,
		}
	},
	methods: {
		searchCustomerCompanies() {
			;(this.dialog = false), this.$emit("search-customer-companies")
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	computed: {
		q: {
			get() {
				return this.query
			},
			set(newValue) {
				return this.$emit("update:query", newValue)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>